<span
  class="flex w-fit items-center justify-center px-2 py-0.5 font-thin"
  [ngClass]="[getColorClasses(), withBorder() ? 'border' : '', rounded() ? 'rounded-full' : 'rounded-md', fontSize(), withIcon() ? 'gap-0.5' : '']"
>
  <span class="flex items-center">
    @if (icon()) {
      @switch (iconType()) {
        @case ("mat-icon") {
          <mat-icon
            class="-mb-1.5"
            style="font-size: 18px"
            [fontIcon]="icon()!"
          ></mat-icon>
        }
        @case ("img") {
          <img
            priority="true"
            alt="icon"
            width="16"
            height="16"
            [ngSrc]="icon()!"
          />
        }
      }
    }
  </span>

  {{ text() }}
</span>
